import logo from '../../images/logo.svg';
import { socialLinks } from '../../data';
import PageLinks from '../PageLinks/PageLinks';
import SocialLink from '../SocialLink/SocialLink';
const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="nav-center">
        <div className="nav-header">
          <img src={logo} className="nav-logo" alt="backroads" />
          <button type="button" className="nav-toggle" id="nav-toggle">
            <i className="fas fa-bars"></i>
          </button>
        </div>
        <PageLinks parentClass="nav-links" itemClass="nav-link" />

        <ul className="nav-icons">
          {socialLinks.map((link) => {
            const { id, href, icon } = link;
            return (
              <SocialLink
                key={id}
                href={href}
                itemClass="nav-icon"
                icon={icon}
              />
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
